var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCircularProgress = function SvgCircularProgress(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "251.5px",
    height: "252.5px",
    viewBox: "24 3.5 251.5 252.5",
    enableBackground: "new 24 3.5 251.5 252.5",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 135.9771,
    y1: 162.8809,
    x2: 137.3776,
    y2: 161.4803,
    gradientTransform: "matrix(103.923 0 0 -60 -13983.1445 9754.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#11CFCF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#14C0D4"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_1_)",
    strokeWidth: 8,
    d: "M150,10c42.872,0,82.487,22.872,103.923,60"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 146.2197,
    y1: 164.7021,
    x2: 146.2197,
    y2: 163.2045,
    gradientTransform: "matrix(16.077 0 0 -120 -2063.9299 19804.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#14C0D4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#16B2D8"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_2_)",
    strokeWidth: 8,
    d: "M253.923,70c21.437,37.128,21.437,82.872,0,120"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 137.3813,
    y1: 162.3389,
    x2: 135.979,
    y2: 160.9365,
    gradientTransform: "matrix(103.923 0 0 -60 -13983.1445 9934.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#16B2D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#19A3DD"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_3_)",
    strokeWidth: 8,
    d: "M253.923,190c-21.436,37.128-61.051,60-103.923,60"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 137.0166,
    y1: 160.9365,
    x2: 135.6161,
    y2: 162.3371,
    gradientTransform: "matrix(103.923 0 0 -60 -14087.0801 9934.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#19A3DD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C93E2"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_4_)",
    strokeWidth: 8,
    d: "M150,250c-42.872,0-82.487-22.872-103.923-60"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 143.124,
    y1: 163.2051,
    x2: 143.124,
    y2: 164.7027,
    gradientTransform: "matrix(16.077 0 0 -120 -2287.8501 19804.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1C93E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1F83E6"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_5_)",
    strokeWidth: 8,
    d: "M46.077,190c-21.436-37.128-21.436-82.872,0-120"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 135.6152,
    y1: 161.4795,
    x2: 137.0178,
    y2: 162.882,
    gradientTransform: "matrix(103.923 0 0 -60 -14087.082 9754.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1F83E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#11CFCF"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_6_)",
    strokeWidth: 8,
    d: "M46.077,70C67.513,32.872,107.128,10,150,10"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCircularProgress, _extends({
    svgRef: ref
  }, props));
});
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };